import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
    faBell,
    faEnvelope,
    faUsers,
    faSearch,
    faStar,
    faFutbol,
    faBook,
    faExchangeAlt,
    faCoins,
    faComments,
    faChevronLeft,
    faChevronRight,
    faNewspaper,
    faInfoCircle,
    faBars,
    faSlidersH,
    faUserEdit,
    faUserSlash,
    faQuestionCircle,
    faPen,
    faTrash,
    faLessThan,
    faGreaterThan,
    faEquals,
    faPlus,
    faCheck,
    faChevronUp,
    faChevronDown,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faSyncAlt,
    faTasks,
    faBatteryHalf,
    faSmile,
    faUserCircle,
    faCrow,
    faCrown,
    faTimesCircle,
    faBatteryEmpty,
    faBatteryFull,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faAngry,
    faFrown,
    faMeh,
    faLaugh,
    faSave,
    faSpider,
    faSpinner,
    faArrowsAlt,
    faCloudRain,
    faSun,
    faShareSquare,
    faShareAlt,
    faEraser,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowDown,
    faSortUp,
    faSortDown,
    faFilter,
 } from '@fortawesome/free-solid-svg-icons';

 import { NgxSliderModule } from '@angular-slider/ngx-slider';
 import { NotifierModule, NotifierConfig, NotifierOptions } from 'angular-notifier'

/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment';
import { ROUTES } from './app.routes';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';


//import '../styles/styles.scss';
//import '../styles/headings.css';
import { 
    MainPage,
    NoContentPage,
    TacticPage,
    LoginPage,
    RosterPage,
  } from './pages';

  import {
    AdminDashboardPage, AdminJobLogsPage, AdminMatchDayListPage, AdminUsersListPage
  } from './pages/admin';


import { ServicesModule } from './services/services.module';


import '../styles/styles.scss';
import 'bootstrap';

import { ComponentsModule } from './components/components.module';
import { EmptyLayout, PublicLayout, PrivateLayout, AdminLayout  } from './layouts';
import { AdminDrawingEuroPage } from './pages/admin/drawings/euro-cups';
import { CommonModule } from '@angular/common';
import { SecondTourPage } from './pages/admin/drawings/second-tour';
import { SecondTour12Page } from './pages/admin/drawings/second-tour-12';
import { DrawingNationalCupsPage } from './pages/admin/drawings/national-cups/national-cups.page';
import { DrawingNationalSuperCupsPage } from './pages/admin/drawings/national-super-cups';
import { DrawingEuroSuperCupPage } from './pages/admin/drawings/euro-super-cup';
import { AdminDrawingClubWorldCupGroup } from './pages/admin/drawings/club-world-cup-group';
import { AdminMaintenancePage } from './pages/admin/maintenance';
import { WCFinalPage } from './pages/admin/drawings/wc-final';
import { WCPlayOffPage } from './pages/admin/drawings/wc-playoff';
import { WCQualificationPage } from './pages/admin/drawings/wc-qualification';
import { NationalTacticPage } from './pages/national';
import { AdminDrawingCarousel, AdminDrawingClubWorldCupPlayoff } from './pages/admin/drawings';
import { PlayersPage } from './pages/players-page';


//notifier options
const notifyOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: false,
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};


// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState
];

interface StoreType {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
}

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
    EmptyLayout,
    PublicLayout,
    PrivateLayout,
    AdminLayout,
    MainPage,
    TacticPage,
    NoContentPage,
    LoginPage,
    AdminDashboardPage,
    AdminUsersListPage,
    AdminMatchDayListPage,
    AdminDrawingEuroPage,
    AdminMaintenancePage,
    SecondTourPage,
    SecondTour12Page,
    DrawingNationalCupsPage,
    DrawingNationalSuperCupsPage,
    DrawingEuroSuperCupPage,
    WCFinalPage,
    WCPlayOffPage,
    WCQualificationPage,
    AdminDrawingClubWorldCupGroup,
    AdminDrawingClubWorldCupPlayoff,
    AdminJobLogsPage,
    RosterPage,
    NationalTacticPage,
    AdminDrawingCarousel,
    PlayersPage,
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(ROUTES, {
      //useHash: Boolean(history.pushState) === false,
      useHash: true,
      preloadingStrategy: PreloadAllModules
    }),
    ServicesModule,
    ComponentsModule,
    NgbModule,
    NgxSliderModule,
    NotifierModule.withConfig(notifyOptions),
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    environment.ENV_PROVIDERS,
    APP_PROVIDERS
  ]
})
export class AppModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(
        faAngry,
        faArrowsAlt,
        faArrowLeft,
        faArrowRight,
        faArrowUp,
        faArrowDown,
        faBell, 
        faBars,
        faBatteryHalf,
        faBatteryEmpty,
        faBatteryFull,
        faBatteryQuarter,
        faBatteryThreeQuarters,
        faBook,
        faCheck,
        faChevronLeft,
        faChevronRight,
        faChevronUp,
        faChevronDown,
        faChevronCircleDown,
        faChevronCircleLeft,
        faChevronCircleRight,
        faChevronCircleUp,
        faCloudRain,
        faCoins,
        faComments,
        faCrown,
        faEnvelope,
        faEquals,
        faEraser,
        faExchangeAlt,
        faFilter,
        faFrown,
        faFutbol,
        faGreaterThan,
        faInfoCircle,
        faLaugh,
        faLessThan,
        faMeh,
        faNewspaper,
        faPen,
        faPlus,
        faQuestionCircle,
        faSave,
        faSearch,
        faShareSquare,
        faSlidersH,
        faShareAlt,
        faSmile,
        faSortDown,
        faSortUp,
        faSpinner,
        faStar,
        faSun,
        faSyncAlt,
        faTasks,
        faTimesCircle,
        faTrash,
        faUserCircle,
        faUserEdit,
        faUsers,
        faUserSlash,
        
      );
  }
}